import { TableHead } from '@/components/Datatable/TableHead';
import { SortableTableHeadersProps } from '@/type/listing.types';

export const VehiculeCheckTypeTableHeaders = ({
  t,
  onSort,
}: SortableTableHeadersProps) => {
  return (
    <>
      <TableHead
        text={t('common:inspectionType')}
        thClassName="min-w-[255px]"
        sortable
        onSortClick={() => onSort?.('vehiculeCheckTypeName')}
      />
      <TableHead text={t('common:group')} thClassName="min-w-[255px]" />
      <TableHead text={t('common:status')} thClassName="min-w-0 w-0" />
      <TableHead text={t('common:performedBy')} thClassName="min-w-0 w-0" />
      <TableHead thClassName="sticky-action-column" />
    </>
  );
};
